﻿export const projectSettings = {
	phoneNumber: (window.projectSettings && window.projectSettings.phoneNumber) || "",
	emailAddress: (window.projectSettings && window.projectSettings.emailAddress) || "",
	classActionName: (window.projectSettings && window.projectSettings.classActionName) || "",
	servicePageUrl: (window.projectSettings && window.projectSettings.servicePageUrl) || "",
	gSiteKey2: (window.projectSettings && window.projectSettings.gSiteKey2) || "",
	gSiteKey3: (window.projectSettings && window.projectSettings.gSiteKey3) || ""
};

const registrationPageIndex = {
	LandingPage: 0,
	PersonalDetails: 1,
	WorkDetails: 2,
	Confirmation: 3,
	ThankYou: 4,
	Review: 5,
	Error: 6
};

const fileUploadPageIndex = {
	FileUploadLandingPage: 0,
	FileUploadFiles: 1,
	FileUploadThankYou: 2,
	Error: 3
};

const registrationPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName}`,
		title: "Landing Page",
		showInTracker: false,
		lastVisitedPage: "Landing Page",
		nextPage: "Registration/PersonalDetails"
	},
	{
		pageIndex: 1,
		title: "Personal Details",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Personal Details`,
		nextPage: "Registration/WorkDetails",
		previousPage: "Registration",
		persistUrl: "api/project",
		lastVisitedPage: "Personal Details"
	},
	{
		pageIndex: 2,
		title: "Work Details",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Work Details`,
		nextPage: "Registration/Confirmation",
		previousPage: "Registration/PersonalDetails",
		persistUrl: "api/project",
		lastVisitedPage: "Work Details"
	},
	{
		pageIndex: 3,
		title: "Confirmation",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Confirmation`,
		nextPage: "Registration/ThankYou",
		nextPageLabel: "Submit",
		previousPage: "Registration/WorkDetails",
		persistUrl: "api/register",
		lastVisitedPage: "Confirmation"
	},
	{
		pageIndex: 4,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Thank you`
	},
	{
		pageIndex: 5,
		title: "Review",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Review`
	},
	{
		pageIndex: 6,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];

const fileUploadPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName}`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "FileUpload/Files"
	},
	{
		pageIndex: 1,
		title: "Files",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Files`,
		nextPage: "FileUpload/Thankyou",
		previousPage: "FileUpload",
		nextPageLabel: "Submit",
		persistUrl: "api/file-upload-submit"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Thank you`
	},
	{
		pageIndex: 3,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];

export const applicationPages = {
	registrationPageIndex: registrationPageIndex,
	registrationPageList: registrationPageList,
	fileUploadPageIndex: fileUploadPageIndex,
	fileUploadPageList: fileUploadPageList
};

export const referralTypes = [
	{ name: "Advertising" },
	{ name: "Client" },
	{ name: "Online" },
	{ name: "Family/Friend" },
	{ name: "Professional Referral" },
	{ name: "Staff Referral" },
	{ name: "Media" },
	{ name: "Word of Mouth" },
	{ name: "Other" }
];

export const salutationTypes = [
	{ name: "Dr" },
	{ name: "Mr" },
	{ name: "Miss" },
	{ name: "Ms" },
	{ name: "Mrs" },
	{ name: "Other" }
];

export const acceptedFileUploadList =
	"application/pdf,.csv,image/*,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/docx,application/pdf,text/plain,application/msword,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const yesNoOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" }
];

export const yesNoUnsureOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" },
	{ label: "Unsure", value: "Unsure" }
];

export const relationshipToClaimant = [{ name: "Mother" }, { name: "Father" }, { name: "Guardian" }];

export const workTypeOptions = [
	{ label: "McDonald's Corporate Store", value: "CORPORATE" },
	{ label: "McDonald's Franchise Store", value: "FRANCHISE" },
	{ label: "Both McDonald's Corporate and Franchise Stores", value: "BOTH" },
	{ label: "I worked at a McDonald's Outlet but I don't know who owned it", value: "UNSURE" }
];

export const nsaType = [
	{ label: "Never", value: "NEVER" },
	{ label: "Sometimes", value: "SOMETIMES" },
	{ label: "Always", value: "ALWAYS" }
];

export const roleClassificationType = [
	{ name: "Crew Member" },
	{ name: "Crew Trainer/Coach" },
	{ name: "Shift Supervisor" },
	{ name: "Shift Manager" },
	{ name: "Restaurant Manager" },
	{ name: "Other" }
];
